// mantine
import { Divider } from '@mantine/core';
// utils
import type { IArgument, TRecording } from '@newo/api/gateway';
import { AudioPlayerControl } from '@newo/ui-kit';
import { argumentsToObject, getRecordingName } from '@newo/toolkit/bff';
import ChannelByIntegrationIdn from '@/components/ChannelByIntegrationIdn';
import { INTEGRATION_TO_CHANNEL } from '@/constants';
// assets
import styles from '@/modules/Chat/components/EventMessage/components/SessionEnded/SessionEnded.module.css';

interface SessionEndedProps {
    args: IArgument[];
    integrationIdn: string | null;
    externalId: string | null;
    recordings: TRecording[];
}

const SessionEnded = ({
    args,
    integrationIdn,
    externalId,
    recordings
}: SessionEndedProps) => {
    const { summary = '', potentialRevenue = '' } = argumentsToObject(args);
    return (
        <>
            <div className="text-sm">{summary}</div>
            <div className="my-2 flex flex-wrap gap-4">
                {recordings.map((recording, index) => {
                    return (
                        <AudioPlayerControl
                            key={recording.play_url}
                            label={getRecordingName(
                                `Recording #${index + 1}`,
                                recording.duration
                            )}
                            size="xs"
                            trackName={externalId ?? ''}
                            trackUrl={recording.play_url}
                            type="button"
                        />
                    );
                })}
            </div>
            <Divider className="my-4" />
            <div className={styles.grid}>
                <div className="text-gray-6">Revenue</div>
                <div className="text-lg text-green-8">{potentialRevenue}</div>
                {integrationIdn ? (
                    <>
                        <div className="text-gray-6">Channel</div>
                        <div className="text-lg text-green-8">
                            <ChannelByIntegrationIdn
                                channel={INTEGRATION_TO_CHANNEL[integrationIdn]}
                                className="text-sm"
                            />
                        </div>
                    </>
                ) : undefined}
            </div>
        </>
    );
};

export default SessionEnded;
